'use client';

import { Box, Heading, KeyValueTable } from '@petsmart-ui/sparky';

import { KeyValueRow } from './KeyValueRow';
import { orderSummaryRows } from './constants';
import type { OrderSummaryRow } from './types';
import { EarnedPoints } from './EarnedPoints';
import { PaymentMethodPreview } from './PaymentMethodPreview';
import type { PaymentMethodPreviewProps } from './PaymentMethodPreview';

export interface OrderSummaryViewProps {
    title?: string;
    earnedPoints?: number;
    paymentMethod?: PaymentMethodPreviewProps;
    rows: OrderSummaryRow[];
}

export function OrderSummaryView({ rows, title, earnedPoints, paymentMethod }: Readonly<OrderSummaryViewProps>) {
    return (
        <Box className="order-summary">
            <Heading tagName="h2" size="headline" className="sparky-u-margin-bottom-md">
                {title ?? 'Order summary'}
            </Heading>
            <KeyValueTable fullWidth className="sparky-u-margin-bottom-sm">
                {rows.map((row, index) => (
                    <KeyValueRow {...orderSummaryRows[row.key]?.getProps(row)} key={`${row.key}_${String(index)}`} />
                ))}
            </KeyValueTable>
            {earnedPoints !== undefined && <EarnedPoints points={earnedPoints} />}
            {paymentMethod && <PaymentMethodPreview {...paymentMethod} />}
        </Box>
    );
}
